import CartActions from '../../../../components/buybox/cart-actions';
import cartActions from './cart-actions';

export default cartActions(CartActions);
